<template>
  <el-card>
    <el-form :inline="true" :model="queryParams" class="query-form">
      <el-form-item v-for="(field, index) in queryFields" :key="index" :label="field.label">
        <el-input
          v-if="field.type === 'input'"
          v-model="queryParams[field.prop]"
          :placeholder="field.placeholder || '请输入'"
        />
        <el-select
          v-if="field.type === 'select'"
          v-model="queryParams[field.prop]"
          :placeholder="field.placeholder || '请选择'"
        >
          <el-option
            v-for="option in field.options"
            :key="option.value"
            :label="option.label"
            :value="option.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="handleQuery"
          :disabled="loading"
          :loading="loading"
        >
          {{ loading ? '查询中...' : '查询' }}
        </el-button>
        <el-button @click="resetQuery">重置</el-button>
        <el-button type="success" @click="handleAdd">新增</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData" style="width: 100%">
      <el-table-column
        v-for="(column, index) in columns"
        :key="index"
        :prop="column.prop"
        :label="column.label"
        :width="column.width"
      >
        <template #default="{ row }" v-if="column.slot">
          <slot :name="column.slot" :row="row" />
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template #default="{ row }">
          <el-button type="primary" size="small" @click="handleEdit(row)">编辑</el-button>
          <el-button type="danger" size="small" @click="handleDelete(row)">删除</el-button>
          <slot name="customActions" :row="row" />
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      style="margin-top: 20px; text-align: right;"
      :current-page="pagination.currentPage"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      @current-change="handlePageChange"
      layout="total, prev, pager, next, jumper"
    />

    <el-dialog
      :visible.sync="dialogVisible"
      :title="dialogTitle"
      width="600px"
      :before-close="handleClose"
    >
      <el-form :model="formData" label-width="100px" class="dialog-form">
        <el-form-item
          v-for="(field, index) in dialogTitle === '新增' ? addFormFields : filteredFormFields"
          :key="index"
          :label="field.label"
          :prop="field.prop"
        >
          <el-input
            v-if="field.type === 'input'"
            v-model="formData[field.prop]"
            :placeholder="field.placeholder || '请输入'"
          />
          <el-select
            v-if="field.type === 'select'"
            v-model="formData[field.prop]"
            :placeholder="field.placeholder || '请选择'"
          >
            <el-option
              v-for="option in field.options"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            />
          </el-select>
          <el-upload
            v-if="field.type === 'image-upload'"
            :action="field.action"
            :headers="field.headers"
            :limit="field.limit"
            :accept="field.accept"
            :on-success="(response, file, fileList) => handleUploadSuccess(response, file, fileList, field.prop)"
            :on-error="handleUploadError"
            :on-remove="handleRemove"
            :file-list="fileList(field.prop)"
          >
            <el-button type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">保存</el-button>
      </template>
    </el-dialog>
  </el-card>
</template>

<script>
export default {
  props: {
    queryFields: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    formFields: {
      type: Array,
      default: () => []
    },
    fetchData: {
      type: Function,
      required: true
    },
    addData: {
      type: Function,
      required: true
    },
    updateData: {
      type: Function,
      required: true
    },
    deleteData: {
      type: Function,
      required: true
    },
    addFields: {
      type: Array,
      default: () => []
    },
    editableFields: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tableData: [],
      queryParams: {},
      dialogVisible: false,
      dialogTitle: '新增',
      formData: {},
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      currentUploadField: ''
    };
  },
  computed: {
    addFormFields() {
      return this.formFields.filter(field => 
        this.addFields.includes(field.prop)
      );
    },
    filteredFormFields() {
      return this.formFields.filter(field => 
        this.editableFields.includes(field.prop)
      );
    }
  },
  methods: {
    handleQuery() {
      this.loading = true;
      const params = {
        ...this.queryParams,
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize
      };
      this.fetchData(params)
        .then(response => {
          this.tableData = response.data.list;
          this.pagination.total = response.data.total;
        })
        .catch(error => {
          this.$message.error('查询失败');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetQuery() {
      this.queryParams = {};
      this.handleQuery();
    },
    handleAdd() {
      this.dialogTitle = '新增';
      this.formData = this.addFields.reduce((acc, field) => {
        acc[field] = '';
        return acc;
      }, {});
      this.dialogVisible = true;
    },
    handleEdit(row) {
      console.log('Editing row:', row);
      this.dialogTitle = '编辑';
      this.formData = { ...row };
      this.dialogVisible = true;
    },
    handleDelete(row) {
      this.$confirm('确认删除该记录吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.deleteData(row.id).then(() => {
          this.$message.success('删除成功');
          this.handleQuery();
        }).catch(error => {
          this.$message.error('删除失败');
        });
      }).catch(() => {});
    },
    handleSubmit() {
      const action = this.formData.id ? this.updateData : this.addData;
      const data = this.formData.id ? { ...this.formData } : this.addFields.reduce((acc, field) => {
        if (this.formData[field] !== undefined && this.formData[field] !== null) {
          acc[field] = this.formData[field];
        }
        return acc;
      }, {});
      action(data).then(() => {
        this.$message.success('操作成功');
        this.dialogVisible = false;
        this.handleQuery();
      }).catch(error => {
        this.$message.error('操作失败');
      });
    },
    handlePageChange(page) {
      this.pagination.currentPage = page;
      this.handleQuery();
    },
    handleUploadSuccess(response, file, fileList, field) {
      if (response.code === 200) {
        this.formData[field] = response.data.url;
        console.log(this.formData);
        this.$message.success(response.message || '上传成功');
      } else {
        this.$message.error(response.message || '上传失败');
      }
    },
    handleUploadError(err, file, fileList) {
      this.$message.error('上传失败');
    },
    handleRemove(file, fileList) {
      this.formData[this.currentUploadField] = '';
    },
    fileList(prop) {
      return this.formData[prop] ? [{ url: this.formData[prop] }] : [];
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    }
  },
  mounted() {
    this.handleQuery();
  }
};
</script>

<style scoped>
.query-form {
  margin-bottom: 20px;
  text-align: left;
}

.dialog-form {
  max-height: 400px;
  overflow-y: auto;
  padding-right: 20px;
}

.el-dialog__body {
  padding: 20px;
}

.el-dialog__footer {
  text-align: right;
  padding: 10px 20px;
}
</style>